import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AppState } from '../_state';
import { currentAuthToken } from '../_state/_selectors/auth.selectors';
import { of } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const store = inject(Store<AppState>);

  return store.pipe(select(currentAuthToken)).pipe(

    map((token) => {
      if (!token) {
        router.navigate(['/'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      } else {
        return true;
      }
    }),
    catchError(() => of(router.createUrlTree(['/'])))
  );
};

// export const authGuard: CanActivateFn = (
//   route: ActivatedRouteSnapshot,
//   state: RouterStateSnapshot
// ) => {
//   const platformId = inject(PLATFORM_ID);

//   const router = inject(Router);

//   if(isPlatformBrowser(platformId)) {
//       if (authenticationService.isLogin()) {
//           return true;
//       } else {
//           router.navigate(['/authentication']);
//           return false;
//       }
//   }
//   return false;
// };
